import { useEffect, useState } from "react";
import api, { money } from "@/lib/api";
import { Card } from "@/components/ui/card";
import FullScreenLoader from "@/components/FullScreenLoader";
import { Store, Users, ShoppingCart, DollarSign, CheckCircle2, Ban } from "lucide-react";

function Stat({ icon: Icon, label, value, accent }) {
  return (
    <Card className="p-5 rounded-xl border-border" data-testid={`platform-stat-${label.toLowerCase().replace(/ /g, "-")}`}>
      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground font-medium">{label}</span>
        <div className={`h-8 w-8 rounded-lg flex items-center justify-center ${accent}`}><Icon className="h-4 w-4" /></div>
      </div>
      <p className="mt-3 text-2xl font-bold font-heading tracking-tight">{value}</p>
    </Card>
  );
}

export default function PlatformDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/platform/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <FullScreenLoader />;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Platform overview</h1>
        <p className="text-muted-foreground mt-1">All storefronts, users, and activity across Drelik.</p>
      </div>
      <div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
        <Stat icon={Store} label="Total Stores" value={stats.total_stores} accent="bg-indigo-100 text-indigo-600" />
        <Stat icon={CheckCircle2} label="Active Stores" value={stats.active_stores} accent="bg-emerald-100 text-emerald-600" />
        <Stat icon={Ban} label="Suspended" value={stats.suspended_stores} accent="bg-red-100 text-red-600" />
        <Stat icon={Users} label="Total Users" value={stats.total_users} accent="bg-blue-100 text-blue-600" />
        <Stat icon={Users} label="Customers" value={stats.total_customers} accent="bg-cyan-100 text-cyan-600" />
        <Stat icon={ShoppingCart} label="Total Orders" value={stats.total_orders} accent="bg-violet-100 text-violet-600" />
        <Stat icon={DollarSign} label="Platform GMV" value={money(stats.gmv)} accent="bg-emerald-100 text-emerald-600" />
      </div>
      <Card className="rounded-xl border-border">
        <div className="p-5 border-b border-border"><h3 className="font-semibold">Subscription plans</h3></div>
        <div className="p-5 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {["starter", "growth", "business", "enterprise"].map((plan) => (
            <div key={plan} className="rounded-lg border border-border p-4 text-center">
              <p className="text-2xl font-bold font-heading">{stats.plan_counts[plan] || 0}</p>
              <p className="text-sm text-muted-foreground capitalize mt-1">{plan}</p>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
